/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Suspense, lazy } from 'react';
import { withTranslation, useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import $ from 'jquery';

import History from '../../History';

import Logo from '../../assets/images/logo2.png';
import Icon12 from '../../assets/images/icon12.png';
import Icon13 from '../../assets/images/icon13.png';
import Icon14 from '../../assets/images/icon14.png';
import Icon15 from '../../assets/images/icon15.png';

class Footer extends React.Component {
  render() {
    const { t } = this.props;

    return (
      <div id="footer">
        <div className="f_inner">
          <ul>
            <li>
              <h1>
                <a href="">
                  <img src={Logo} alt="" />
                </a>
              </h1>
              <ul className="sns">
                <li>
                  <a href="#">
                    <img src={Icon12} alt="" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src={Icon13} alt="" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src={Icon14} alt="" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src={Icon15} alt="" />
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <h2>{t('회사')}</h2>
              <ul className="ft">
                <li>{t('㈜케이피앤피')}</li>
                <li>{t('대표: 이인수')}</li>
                <li>{t('사업자번호: 120-87-14487')}</li>
              </ul>
            </li>
            <li>
              <h2>{t('주소')}</h2>
              <ul className="ft">
                <li>{t('08594 서울특별시 금천구 가산디지털1로 19')}</li>
                <li>{t('가산동, 대륭테크노타운18차')}</li>
                <li>{t('1805호')}</li>
              </ul>
            </li>
            <li>
              <h2>{t('연락처')}</h2>
              <ul className="ft">
                <li>{t('이메일: info@kpnp.k')}r</li>
                <li>02-563-5989</li>
              </ul>
            </li>
            <li>
              <h2>{t('TERMS')}</h2>
              <ul className="trs">
                <li>
                  <a href="#">{t('개인정보보호정책')}</a>
                </li>
                <li>
                  <a href="#">{t('홈페이지용약관')}</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <p>Copyright © KPNP CO.,LTD. All rights reserved.</p>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

export default connect(mapStateToProps, {})(withTranslation()(Footer));
